import React, { useCallback, useState } from 'react'
import AutocompleteTransfixUser, {
  TBaseValue,
} from 'transfix-ui/components/AutocompleteTransfixUser'
import { FormModal, IModalAction } from 'transfix-ui/components/Modals'
import { Box } from 'transfix-ui/core'
import { ShipperRateObjectAugmented } from '../../../utils/hooks/AwardedLanes/useAwardedLanesApi'
import { useCarrierSalesRep } from './AwardedLaneModal/Sidebar/CarrierSalesRepSelector/hooks/useCarrierSalesRep'
import { LaneHeader } from './LaneHeader'
import '../AwardedLanes.scss'

interface IReassignModalProps {
  currentRate: ShipperRateObjectAugmented
  onSuccess: () => void
  onClose: () => void
}

export const ReassignModal = ({ currentRate, onClose, onSuccess }: IReassignModalProps) => {
  const { carrierSalesRep, id: shipperRateId, salesRepName } = currentRate || {}
  const { id: salesRepId } = carrierSalesRep || {}

  const [user, setUser] = useState<TBaseValue | null>({
    id: `${salesRepId}`,
    text: salesRepName,
  })
  const { id: userId = null } = user || {}

  const [errors, setErrors] = useState<string[]>([])

  const { loading, reassign } = useCarrierSalesRep({
    awardedLaneId: `${shipperRateId}`,
  })

  const saveHandler = useCallback(() => {
    if (userId !== `${salesRepId}`) {
      reassign(userId).then(({ errors }) => {
        if (errors && errors.length > 0) {
          setErrors(errors.map(error => error.message))
        } else {
          onSuccess()
        }
      })
    } else {
      onClose()
    }
  }, [onClose, onSuccess, reassign, salesRepId, userId])

  const modalActions: IModalAction[] = [
    {
      label: 'Cancel',
      type: 'dismiss',
      disabled: loading,
      dataTest: 'cancel-reassign-carrier-sales',
    },
    {
      label: 'Save',
      type: 'confirm',
      action: saveHandler,
      disabled: loading,
      dataTest: 'reassign-carrier-sales',
    },
  ]

  return (
    <FormModal
      title='Edit Carrier Sales Representative'
      size={6}
      open
      onClose={onClose}
      dataTest='carrier-sales-reassign-modal'
      error={errors}
      className='awarded-lanes-modal'
      actions={modalActions}>
      <LaneHeader rate={currentRate} />
      <Box mt={1} width='50%'>
        <AutocompleteTransfixUser value={user} onChange={setUser} renderInputType='withAvatar' />
      </Box>
    </FormModal>
  )
}
